import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Loader2, ArrowLeft, ShieldCheck, Lock } from "lucide-react";
import memberApi from "../../lib/memberApi";
import { PortalNav } from "../../components/portal/PortalNav";

export default function AllyPage() {
  const [data, setData] = useState(null);
  const [locked, setLocked] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    memberApi.get("/member/ally")
      .then((r) => setData(r.data))
      .catch((e) => { if (e?.response?.status === 403) setLocked(true); })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#050505] noise-overlay text-white">
      <PortalNav />
      <main className="max-w-3xl mx-auto px-5 sm:px-8 py-10 sm:py-14">
        <Link to="/portal" className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-white/40 hover:text-white transition-colors mb-8">
          <ArrowLeft size={14} /> Back to dashboard
        </Link>
        {loading ? (
          <div className="flex items-center justify-center py-32"><Loader2 className="animate-spin text-accent" size={28} /></div>
        ) : locked ? (
          <div data-testid="ally-locked" className="border border-accent/40 bg-[#160606] p-8">
            <div className="flex items-center gap-2 mb-3"><Lock size={16} className="text-accent" /><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">Bonus locked</span></div>
            <h1 className="font-display font-black uppercase text-2xl mb-3">Ghost Ally Toolkit</h1>
            <p className="font-body text-sm text-white/60 leading-relaxed mb-6">Refer a friend who joins through your link to unlock this advanced maintenance kit. Grab your personal link from the dashboard.</p>
            <Link to="/portal" className="inline-flex items-center gap-2 bg-accent text-white font-mono uppercase tracking-[0.15em] text-xs px-6 py-3 hover:bg-white hover:text-black transition-colors">Get my referral link</Link>
          </div>
        ) : data ? (
          <motion.article initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <div className="flex items-center gap-2 mb-3"><ShieldCheck size={16} className="text-accent" /><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-accent">Referral reward · Unlocked</span></div>
            <h1 data-testid="ally-title" className="font-display font-black uppercase tracking-tight text-3xl sm:text-4xl mb-8">{data.title}</h1>
            <div className="portal-md" data-testid="ally-body">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{data.markdown}</ReactMarkdown>
            </div>
          </motion.article>
        ) : null}
      </main>
    </div>
  );
}
